import { lazy } from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import * as workoutPlanApi from '../../services/workoutPlanApi';

const WorkoutPlanForm = lazy(() => import('./WorkoutPlanForm'));
const WorkoutPlanView = lazy(() => import('./WorkoutPlanView'));

export const workoutPlanConfig = {
  id: 'workoutPlans',
  resourceType: 'workout_plan',
  singularName: 'Workout Plan',
  addButtonLabel: 'Create Workout',
  pluralName: 'Workout Plans',
  icon: AssignmentIcon,
  searchable: true,
  usePreviewModal: true,
  enableFavorites: true,
  favoriteResourceType: 'workout_plan',
  createHeaderTitle: "Create Your Workout",
  createHeaderDescription: "Choose how you'd like to build your workout",
  modalSize: 'lg',
  getDisplayName: (item) => item.name || '',
  sortOptions: [
    {
      label: 'Sort by Date Modified',
      value: 'date',
      sorter: (a, b, additionalProps) => {
        const dateB = new Date(b.updated_at || b.created_at);
        const dateA = new Date(a.updated_at || a.created_at);
        return dateB - dateA;
      },
    },
    {
      label: 'Sort by Name',
      value: 'name',
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
    },
    {
      label: 'Sort by Stage Count',
      value: 'stage_count',
      sorter: (a, b, additionalProps) => {
        const countB = b.stages?.length || 0;
        const countA = a.stages?.length || 0;
        if (countB !== countA) {
          return countB - countA;
        }
        return (a.name || '').localeCompare(b.name || '');
      },
    },
  ],
  getInitialState: (data) => ({
    id: data?.id || null,
    chat_session_id: data?.chat_session_id || null,
    name: data?.name || '',
    description: data?.description || '',
    stages: data?.stages || [],
    shadows_id: data?.shadows_id || null,
    user_id: data?.user_id,
    _isPartial: data?._isPartial || false,
  }),
  api: {
    getAll: () => workoutPlanApi.getWorkoutPlans({
      fields: 'id,name,description,created_at,updated_at,chat_session_id'
    }),
    create: workoutPlanApi.createWorkoutPlan,
    update: workoutPlanApi.updateWorkoutPlan,
    delete: workoutPlanApi.deleteWorkoutPlan,
    getById: workoutPlanApi.getWorkoutPlanById,
  },
  getAdditionalProps: async () => {
    return {
      allActivities: [],
      isLoadingActivities: false,
      allLocations: [],
    };
  },
  FormComponent: WorkoutPlanForm,
  ViewComponent: WorkoutPlanView,
};